<template>
  <section id="questions" class="bg-primary hidden lg:block">
    <div class="md:container px-4 lg:-mt-16 -mt-24 lg:pt-32 lg:pb-62">
      <div class="flex flex-wrap lg:flex-nowrap justify-center text-center text-white mb-4">
        <div class="w-full lg:w-1/2 lg:mr-6 lg:mb-0 mb-10 bg-gold rounded-16 p-6 doctor">
          <img v-lazy-load data-src="@/assets/icon/icon-doctor-line.svg" alt="" class="mx-auto" width="50px" height="73px">
          <h2 class="my-6 font-bree-serif text-2xl">
            {{ $t('quest.questionDoctor') }}
          </h2>
          <p>{{ $t('quest.answerDoctor') }}</p>
        </div>
        <div class="w-full lg:w-1/2 bg-gold rounded-16 p-6 hospital">
          <img v-lazy-load data-src="@/assets/icon/icon-hospital-line.svg" alt="" class="mx-auto" width="73px" height="73px">
          <h2 class="my-6 font-bree-serif text-2xl">
            {{ $t('quest.questionHospital') }}
          </h2>
          <p>{{ $t('quest.answerHospital') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Questions'
}
</script>

<style lang="scss">
  #questions {
    .doctor {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        top: -39px;
        left: 30%;
        width: 0;
        height: 0;
        border-left: 25px solid transparent;
        border-right: 25px solid transparent;
        border-bottom: 40px solid #E0AF06;
      }
    }
    .hospital {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        top: -39px;
        left: 15%;
        width: 0;
        height: 0;
        border-left: 25px solid transparent;
        border-right: 25px solid transparent;
        border-bottom: 40px solid #E0AF06;
      }
      &::after {
        content: '';
        position: absolute;
        top: -39px;
        left: 65%;
        width: 0;
        height: 0;
        border-left: 25px solid transparent;
        border-right: 25px solid transparent;
        border-bottom: 40px solid #E0AF06;
      }
    }
  }
</style>
